import styled from 'styled-components';

export default styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
